import type { EnnismoreTheme } from '@/ui/theme';

import { morgansOriginalsTheme } from './morgansoriginals.theme';

export const morgansOriginalsSandersonTheme: EnnismoreTheme = {
  ...morgansOriginalsTheme,
  logoUrl: '/brands/morgansoriginals/images/morgans-sanderson-logo.svg',
};
